export interface DeductionStageProps {
  stageId: number;
  stageKey: string;
  stageName: string;
  isCurrent: boolean;
}

export class DeductionStage {
  private readonly _stageId: number;
  private readonly _stageKey: string;
  private readonly _stageName: string;
  private readonly _isCurrent: boolean;

  constructor(props: DeductionStageProps) {
    this._stageId = props.stageId;
    this._stageKey = props.stageKey;
    this._stageName = props.stageName;
    this._isCurrent = props.isCurrent;
  }

  public get stageId(): number {
    return this._stageId;
  }

  public get stageKey(): string {
    return this._stageKey;
  }

  public get stageName(): string {
    return this._stageName;
  }

  public get isCurrent(): boolean {
    return this._isCurrent;
  }
}
